<template>
  <nav class="body__sidebar" id="body__sidebar" aria-label="Menú de servicio de mesa">
    <div class="nav-mob-resp">
      <hidden-arrow></hidden-arrow>
      <div class="title">
        <div class="title__icon" aria-hidden="true">
          <i class="fas fa-utensils"></i>
        </div>
        <div class="title__text">
          <h2 :title="company_name">{{ company_name }}</h2>
          <p>Servicio de mesa</p>
        </div>
      </div>
      <div class="tabs">
        <router-link to="/pos-resumen" class="tab" :class="{ active: active === 'dashboard' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-chart-line"></i>
          </div>
          <div class="tab__text">
            <p>Resumen</p>
          </div>
        </router-link>
        <router-link to="/mesas" class="tab" :class="{ active: active === 'mesas' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-chair"></i>
          </div>
          <div class="tab__text">
            <p>Mesas</p>
          </div>
        </router-link>
        <router-link to="/menu-mesas" class="tab" :class="{ active: active === 'menu' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-book-open"></i>
          </div>
          <div class="tab__text">
            <p>Menú</p>
          </div>
        </router-link>
        <router-link to="/pos-mesas" class="tab" :class="{ active: active === 'pos' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-cash-register"></i>
          </div>
          <div class="tab__text">
            <p>POS</p>
          </div>
        </router-link>
        <router-link to="/pos-comprobantes" class="tab" :class="{ active: active === 'comprobantes' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-file-invoice"></i>
          </div>
          <div class="tab__text">
            <p>Comprobantes</p>
          </div>
        </router-link>
        <router-link to="/pos-api-test" class="tab" :class="{ active: active === 'api-test' }">
          <div class="tab__icon" aria-hidden="true">
            <i class="fas fa-flask"></i>
          </div>
          <div class="tab__text">
            <p>API Test</p>
          </div>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import HiddenArrow from '@/components/HiddenArrow.vue'

export default {
  name: 'MesasSidebar',
  components: {
    HiddenArrow
  },
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      company_name: localStorage.getItem('company_name')
    }
  }
}
</script>
